import React, {PureComponent} from 'react';

import {Flex} from 'reflexbox';
import uuid from 'uuid';
import toSentenceCase from 'to-sentence-case';

import MdMic from 'react-icons/lib/md/mic';
import IoCheckmarkRound from 'react-icons/lib/io/checkmark-round';

import CircleButton from './CirleButton.js'
import TextInput from './TextInput.js';

export default class Input extends PureComponent {
  constructor(props) {
    super();
    this.state = {text: '', recognizing: false, recording: false};
    this.apiUrl = "https://l7htw6vli2.execute-api.us-east-2.amazonaws.com/prod";
    this.confidenceTheshold = .6;

    if (window.speechRecognition || window.webkitSpeechRecognition) {
      this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();

      this.recognition.onstart = this.handleRecognitionStart;
      this.recognition.onend = this.handleRecognitionEnd;
      this.recognition.onresult = this.handleRecognitionResult;
      this.recognition.onspeechstart = this.handleSpeechStart;
      this.recognition.onspeechend = this.handleSpeechEnd;

      this.speechQuery = null;
    } else {
      this.recognition = null;
    }
  }

  componentWillUpdate= (newProps) => {
    if(!this.props.playing && newProps.playing) {
      if (this.state.recording) {
        this.recognition.stop();
        if (this.speechQuery) {
          this.props.deleteMessage(this.speechQuery);
          this.speechQuery = null;
        }
      }
    }

    if(this.props.playing && !newProps.playing) {
      if (this.state.recording){
        this.recognition.start();
      }
    }
  }

  handleToggleRecording = () => {
    if (this.recognition){
      const recording = !this.state.recording;
      if (recording) {
        if (!this.state.recognizing){
          this.recognition.start();
        }
      } else {
        if (this.state.recognizing){
          this.recognition.stop();
          if (this.speechQuery) {
            this.props.deleteMessage(this.speechQuery);
            this.speechQuery = null;
          }
        }
      }
      this.setState({recording});
    }
  }

  handleRecognitionStart = (e) => {
    this.setState({recognizing: true});
  }

  handleRecognitionEnd = (e) => {
    this.setState({recognizing: false});
    if (!this.props.playing && this.state.recording) {
      this.recognition.start();
      if (this.speechQuery) {
        this.props.deleteMessage(this.speechQuery);
        this.speechQuery = null;
      }
    }
  }

  handleRecognitionResult = (e) => {
    const message = e.results[0][0].transcript
    if (e.results[0].isFinal) {
      this.setState({recognizing: false});
      this.sendMessage(toSentenceCase(message), true);
      this.speechQuery = null;
      this.recognition.stop();
    } else {
      this.setState({text: message});
    }
  }

  handleSpeechStart = (e) => {
    this.speechQuery = this.speechQuery ? this.speechQuery : uuid();
    this.props.updateMessages({author: 'user', pending:true, query: this.speechQuery});
  }

  handleMessageText = (e) => {this.setState({text: e.target.value})}

  handleMessageEnter = (e) => {
    let message = this.state.text;
    this.setState({text: ""});
    this.sendMessage(message, false)
  };

  sendMessage = (message, speech) => {
    let userResponseTo;
    if (speech) {
      userResponseTo = this.speechQuery;
      this.speechQuery = null;
    };

    this.props.updateMessages({author: 'user', text: message, responseTo: userResponseTo, query: null});
    this.props.updateMessages({author: 'ai', pending: true, query: message});

    let data = {
      ssid: this.props.uuid,
      q: message,
      context: JSON.stringify({entities: 'mock entities'}),
      confidence: this.confidenceTheshold,
    };

    return fetch(`${this.apiUrl}/converse`, {
      headers: {
        'Accept': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    })
    .then(response => {
      return response.json();
    })
    .then(json => {
      let intent = json.context.intent[0].value;
      this.props.updateMessages({author: 'ai', text:json.msg, responseTo: message, query: intent});
    })
    .catch(err => {
      const errText = "I'm sorry, you seem to be having network issues and I can't find the answer to your question";
      this.props.updateMessages({author: 'ai', text:errText, responseTo: message, err: true});
    })
  }

  render() {
    return (
      <Flex style={{width:'100%', minHeight: 100, marginTop: 15, marginBottom:15}}>
        <TextInput
          text={this.state.text}
          onChange={this.handleMessageText}
          onEnter={this.handleMessageEnter}
        />
        <Flex flexColumn={true} justify={'space-between'}>
          <CircleButton
            title="enter"
            onClick={this.handleMessageEnter}
            disabled={this.state.text === ""}
          >
            <IoCheckmarkRound/>
          </CircleButton>
          <CircleButton
            title="record"
            active={this.state.recording}
            onClick={this.handleToggleRecording}
            disabled={!this.recognition || this.props.playing}
          >
            {this.state.recognizing ?
              <MdMic/> :
              <MdMic/>
            }
          </CircleButton>
        </Flex>
      </Flex>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Input.js